import { useEffect } from "react";

export interface ProductReviewProps {
  id: string;
  price: string;
  currency: string;
  name: string;
  url: string;
  imageUrl: string;
}

export const YotpoProductReview = (prop: ProductReviewProps) => {
  useEffect(() => {
    if (window?.yotpo) {
      window.yotpo.refreshWidgets();
    }
  }, [prop.id]);

  return (
    <div
      data-product-id={prop.id}
      data-price={prop.price}
      data-currency={prop.currency}
      data-name={prop.name}
      data-url={prop.url}
      data-image-url={prop.imageUrl}
      className="yotpo yotpo-main-widget"
      data-yotpo-element-id="1"
    ></div>
  );
};
